import $ from 'jquery/src/jquery';
import SiteHeader from "./site-header";

export default () => {
    const nodeSelectors = {
        container: '[js-site-nav-mobile="container"]',
        opener: '[js-site-nav-mobile="opener"]',
        closer: '[js-site-nav-mobile="closer"]',
    }

    function init() {
        if (!document.querySelector(nodeSelectors.container)) {
            return
        }

        initNav()
    }

    function initNav() {
        $(document).keyup(function(e) {
            if (e.key === "Escape") {
                close();
            }
        });

        $(nodeSelectors.opener).on('click', function () {
            if( $(nodeSelectors.container).is(':visible') ) {
                close()
            } else {
                open()
            }
        })

        $(nodeSelectors.closer).on('click', function () {
            close()
        })

        $(nodeSelectors.container + ' .menu-item-has-children').on('click', function (e) {
            e.stopPropagation()

            $(this).toggleClass('submenu-is-active')

            let subMenu = $(this).find(' > .sub-menu')

            if( !subMenu.is(':visible') ) {
                e.preventDefault()
            } else {

            }

            subMenu.slideToggle()
        })
    }

    function open() {
        $('body, html').addClass('gl-header-no-scroll')
        $(nodeSelectors.opener).addClass('hamburger--active');
        $(nodeSelectors.container).fadeIn(250);
        $(SiteHeader().nodeSelectors.container).addClass('nav-is-active')
    }

    function close() {
        $('body, html').removeClass('gl-header-no-scroll')
        $(nodeSelectors.container).fadeOut(200);
        $(nodeSelectors.opener).removeClass('hamburger--active');
        $(SiteHeader().nodeSelectors.container).removeClass('nav-is-active')
    }

    return Object.freeze({
        init,
    })
}